import { SpinnerOverlay } from 'components/SpinnerOverlay'

export const Authenticating = () => <SpinnerOverlay />
